// extracted by mini-css-extract-plugin
export var changeIcon = "_4l-4";
export var container = "_4l-0";
export var divider = "_4l-7";
export var externalLinkIcon = "_4l-1";
export var green = "_4l-5";
export var helpCircleIcon = "_4l-3";
export var iconButton = "_4l-2";
export var red = "_4l-6";